export const formQuestions = [
  {
    id: "business_name",
    label: "Business name",
    shortLabel: "Business name"
  },
  {
    id: "niche",
    label: "Niche",
    shortLabel: "Niche"
  },
  {
    id: "main_bottleneck",
    label: "Main bottleneck",
    shortLabel: "Main bottleneck"
  },
  {
    id: "monthly_budget",
    label: "Monthly budget",
    shortLabel: "Monthly budget"
  },
  {
    id: "timeline_to_start",
    label: "Timeline",
    shortLabel: "Timeline"
  },
  {
    id: "website_link",
    label: "Website link",
    shortLabel: "Website"
  },
  {
    id: "city",
    label: "City",
    shortLabel: "City"
  }
];

export const leads = [
  {
    id: "lead_1001",
    submittedAt: "2026-06-20T09:12:00-04:00",
    name: "Marc Tremblay",
    company: "Tremblay Roofing",
    email: "marc.demo@example.com",
    phone: "+1 514-555-0134",
    source: "Facebook Lead Ad",
    campaign: "Roofing Emergency Leads - Montreal",
    status: "Qualified",
    score: 92,
    owner: "Setter A",
    answers: {
      business_name: "Tremblay Roofing",
      niche: "Residential roofing",
      main_bottleneck: "Too many missed quote requests after hours and no clear follow-up system.",
      monthly_budget: "$4,000 - $6,000",
      timeline_to_start: "This month",
      website_link: "https://tremblayroofing.example",
      city: "Montreal"
    },
    analysis: {
      intent: "High",
      summary: "Marc has active monthly budget, a clear response-time problem, and urgency tied to missed emergency roofing jobs.",
      callPriority: "Call today. Lead has budget and operational pain.",
      opener: "You mentioned missed quote requests after hours. How many jobs do you think are slipping through each week?",
      risks: ["May already have a basic CRM", "Could be sensitive to monthly retainers"],
      talkingPoints: ["Speed-to-lead automation", "Missed-call text-back", "Simple pipeline for estimates", "After-hours capture"]
    }
  },
  {
    id: "lead_1002",
    submittedAt: "2026-06-20T09:27:00-04:00",
    name: "Sofia Nguyen",
    company: "Bloom Skin Studio",
    email: "sofia.demo@example.com",
    phone: "+1 438-555-0189",
    source: "Instagram Lead Form",
    campaign: "Med Spa Consultation Funnel",
    status: "New",
    score: 81,
    owner: "Unassigned",
    answers: {
      business_name: "Bloom Skin Studio",
      niche: "Med spa and skincare",
      main_bottleneck: "Consultation requests come in from Instagram DMs, forms, and calls, but follow-up is messy.",
      monthly_budget: "$2,000 - $3,500",
      timeline_to_start: "Within 30 days",
      website_link: "https://bloomskinstudio.example",
      city: "Laval"
    },
    analysis: {
      intent: "Medium-high",
      summary: "Sofia is juggling several lead channels and wants a cleaner intake process before monthly budget scales.",
      callPriority: "Call within 24 hours while the pain is fresh.",
      opener: "Where do consultation requests usually get lost: DMs, calls, or form submissions?",
      risks: ["May need education on CRM workflow", "Could be more interested in operations than ads"],
      talkingPoints: ["DM-to-form follow-up", "Appointment reminders", "Consultation pipeline", "No-show reduction"]
    }
  },
  {
    id: "lead_1003",
    submittedAt: "2026-06-20T10:03:00-04:00",
    name: "David Cohen",
    company: "Cohen Family Dental",
    email: "david.demo@example.com",
    phone: "+1 514-555-0177",
    source: "Google Ads Form",
    campaign: "Dental Implant Consultations",
    status: "Hot",
    score: 96,
    owner: "Setter B",
    answers: {
      business_name: "Cohen Family Dental",
      niche: "Dental implants",
      main_bottleneck: "Leads ask about pricing, then disappear before booking a consultation.",
      monthly_budget: "$8,000+",
      timeline_to_start: "Immediately",
      website_link: "https://cohenfamilydental.example",
      city: "Montreal"
    },
    analysis: {
      intent: "Very high",
      summary: "David has premium-service leads and a booking conversion issue, not a traffic issue.",
      callPriority: "Top priority. Strong budget and immediate timeline.",
      opener: "When implant leads ask about price, what follow-up happens in the next 10 minutes?",
      risks: ["May need compliance-conscious messaging", "Multiple decision makers"],
      talkingPoints: ["Consultation booking sequence", "Lead education drip", "Fast response windows", "Treatment-plan pipeline"]
    }
  },
  {
    id: "lead_1004",
    submittedAt: "2026-06-20T10:31:00-04:00",
    name: "Elena Rossi",
    company: "Rossi Realty Group",
    email: "elena.demo@example.com",
    phone: "+1 647-555-0155",
    source: "Facebook Lead Ad",
    campaign: "Home Seller Valuation Funnel",
    status: "Needs Nurture",
    score: 67,
    owner: "Setter A",
    answers: {
      business_name: "Rossi Realty Group",
      niche: "Real estate listings",
      main_bottleneck: "Seller leads are curious but not ready. Follow-up takes too much manual time.",
      monthly_budget: "$1,500 - $2,500",
      timeline_to_start: "Next quarter",
      website_link: "https://rossirealtygroup.example",
      city: "Toronto"
    },
    analysis: {
      intent: "Medium",
      summary: "Elena has a nurture problem and a longer start timeline, making this a good pipeline automation discussion.",
      callPriority: "Nurture call. Qualify urgency before pitching implementation.",
      opener: "How long is your follow-up sequence for seller leads before they go cold?",
      risks: ["Timeline is not urgent", "Budget may be modest"],
      talkingPoints: ["Long-term seller nurture", "Valuation follow-up", "Appointment reminders", "Lead scoring"]
    }
  },
  {
    id: "lead_1005",
    submittedAt: "2026-06-20T11:08:00-04:00",
    name: "Anthony Brooks",
    company: "Brooks HVAC",
    email: "anthony.demo@example.com",
    phone: "+1 514-555-0108",
    source: "TikTok Lead Form",
    campaign: "Summer AC Repair Leads",
    status: "Qualified",
    score: 88,
    owner: "Setter C",
    answers: {
      business_name: "Brooks HVAC",
      niche: "HVAC services",
      main_bottleneck: "Inbound calls spike during heat waves and the team cannot follow up fast enough.",
      monthly_budget: "$3,000 - $5,000",
      timeline_to_start: "Before next campaign",
      website_link: "https://brookshvac.example",
      city: "Montreal"
    },
    analysis: {
      intent: "High",
      summary: "Anthony has seasonal urgency and needs speed-to-lead plus capacity management.",
      callPriority: "Call soon. Tie solution to upcoming campaign timing.",
      opener: "When a heat wave hits, what happens to missed calls and unbooked requests?",
      risks: ["Seasonal workload may delay implementation", "May prefer call center help"],
      talkingPoints: ["Missed-call text-back", "Service request triage", "Maintenance-plan nurture", "Fast booking workflow"]
    }
  },
  {
    id: "lead_1006",
    submittedAt: "2026-06-20T11:44:00-04:00",
    name: "Priya Shah",
    company: "Northside Physio",
    email: "priya.demo@example.com",
    phone: "+1 416-555-0192",
    source: "Instagram Lead Form",
    campaign: "Physio Injury Assessment",
    status: "New",
    score: 74,
    owner: "Unassigned",
    answers: {
      business_name: "Northside Physio",
      niche: "Physiotherapy",
      main_bottleneck: "New patient inquiries are not consistently assigned to the right location.",
      monthly_budget: "$1,000 - $2,000",
      timeline_to_start: "In the next 60 days",
      website_link: "https://northsidephysio.example",
      city: "Ottawa"
    },
    analysis: {
      intent: "Medium",
      summary: "Priya needs routing clarity between locations and better inquiry ownership.",
      callPriority: "Good fit if multi-location routing is painful enough.",
      opener: "How do you decide which location or practitioner gets a new patient inquiry?",
      risks: ["Moderate budget", "Could need integration with existing booking tool"],
      talkingPoints: ["Location-based routing", "New patient intake", "Booking reminders", "Lead ownership"]
    }
  },
  {
    id: "lead_1007",
    submittedAt: "2026-06-20T12:18:00-04:00",
    name: "Camille Dubois",
    company: "Atelier Dubois",
    email: "camille.demo@example.com",
    phone: "+1 514-555-0140",
    source: "Facebook Lead Ad",
    campaign: "Custom Kitchen Design Leads",
    status: "Qualified",
    score: 84,
    owner: "Setter B",
    answers: {
      business_name: "Atelier Dubois",
      niche: "Custom cabinetry",
      main_bottleneck: "Leads need education before booking because projects are high-ticket.",
      monthly_budget: "$2,500 - $4,000",
      timeline_to_start: "Within 30 days",
      website_link: "https://atelierdubois.example",
      city: "Montreal"
    },
    analysis: {
      intent: "High",
      summary: "Camille sells high-ticket projects and needs a pre-call education path before consultation booking.",
      callPriority: "Strong fit. Explore qualification and project-readiness scoring.",
      opener: "What information do prospects usually need before they feel ready to book a design consult?",
      risks: ["Long sales cycle", "May need portfolio assets organized first"],
      talkingPoints: ["Qualification questions", "Project budget scoring", "Consultation booking", "Education nurture sequence"]
    }
  },
  {
    id: "lead_1008",
    submittedAt: "2026-06-20T13:02:00-04:00",
    name: "Nicolas Girard",
    company: "Girard Legal",
    email: "nicolas.demo@example.com",
    phone: "+1 450-555-0162",
    source: "LinkedIn Lead Gen",
    campaign: "Business Immigration Consults",
    status: "Needs Review",
    score: 71,
    owner: "Setter C",
    answers: {
      business_name: "Girard Legal",
      niche: "Business immigration law",
      main_bottleneck: "Consultations get booked, but many leads are not qualified for the service.",
      monthly_budget: "$3,500 - $5,000",
      timeline_to_start: "This quarter",
      website_link: "https://girardlegal.example",
      city: "Brossard"
    },
    analysis: {
      intent: "Medium",
      summary: "Nicolas has lead quality issues and needs stronger qualification before calendar booking.",
      callPriority: "Useful consult if framed around filtering and saved attorney time.",
      opener: "What makes a consultation unqualified after it is already booked?",
      risks: ["Legal advertising sensitivity", "May need more approval steps"],
      talkingPoints: ["Qualification gates", "Calendar protection", "Intake logic", "Pre-call document collection"]
    }
  },
  {
    id: "lead_1009",
    submittedAt: "2026-06-20T13:39:00-04:00",
    name: "Rachel Green",
    company: "Green Fitness Lab",
    email: "rachel.demo@example.com",
    phone: "+1 514-555-0111",
    source: "TikTok Lead Form",
    campaign: "Transformation Challenge",
    status: "New",
    score: 63,
    owner: "Unassigned",
    answers: {
      business_name: "Green Fitness Lab",
      niche: "Personal training",
      main_bottleneck: "A lot of interest comes in, but people do not show up for intro calls.",
      monthly_budget: "$800 - $1,500",
      timeline_to_start: "Not sure yet",
      website_link: "https://greenfitnesslab.example",
      city: "Montreal"
    },
    analysis: {
      intent: "Low-medium",
      summary: "Rachel has a no-show and commitment issue, but the timeline and budget are less clear.",
      callPriority: "Nurture and qualify budget before spending deep call time.",
      opener: "When someone books an intro call, what reminders or prep do they receive before showing up?",
      risks: ["Low budget", "Unclear urgency"],
      talkingPoints: ["Appointment reminders", "Challenge lead nurture", "No-show recovery", "Simple lead scoring"]
    }
  },
  {
    id: "lead_1010",
    submittedAt: "2026-06-20T14:16:00-04:00",
    name: "Omar Haddad",
    company: "Haddad Auto Detail",
    email: "omar.demo@example.com",
    phone: "+1 514-555-0181",
    source: "Facebook Lead Ad",
    campaign: "Ceramic Coating Offers",
    status: "Hot",
    score: 90,
    owner: "Setter A",
    answers: {
      business_name: "Haddad Auto Detail",
      niche: "Auto detailing",
      main_bottleneck: "People ask for prices in Messenger and disappear before choosing a package.",
      monthly_budget: "$2,000 - $4,000",
      timeline_to_start: "This month",
      website_link: "https://haddadautodetail.example",
      city: "Laval"
    },
    analysis: {
      intent: "High",
      summary: "Omar has a strong offer, monthly budget, and a clear Messenger-to-booking conversion problem.",
      callPriority: "High priority. Strong demo candidate for automated follow-up.",
      opener: "When someone asks for ceramic coating prices in Messenger, what happens next?",
      risks: ["May want immediate revenue proof", "Package/pricing complexity"],
      talkingPoints: ["Messenger follow-up", "Package qualification", "Before/after proof flow", "Booking sequence"]
    }
  }
];

export function getLeadById(id) {
  return leads.find((lead) => lead.id === id) || null;
}

export function getLeadStats() {
  const hot = leads.filter((lead) => lead.status === "Hot").length;
  const qualified = leads.filter((lead) => lead.status === "Qualified").length;
  const avgScore = Math.round(leads.reduce((sum, lead) => sum + lead.score, 0) / leads.length);
  const assigned = leads.filter((lead) => lead.owner !== "Unassigned").length;

  return {
    total: leads.length,
    hot,
    qualified,
    avgScore,
    assigned
  };
}
